var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.951782 10.4413C0.951782 10.9458 1.35854 11.3551 1.85989 11.3551H10.941C11.4423 11.3551 11.8491 10.9458 11.8491 10.4413V7.0909H0.951782V10.4413ZM4.58422 9.14684C4.58422 9.0212 4.68638 8.9184 4.81124 8.9184H7.38422C7.50909 8.9184 7.61125 9.0212 7.61125 9.14684V9.90829C7.61125 10.0339 7.50909 10.1367 7.38422 10.1367H4.81124C4.68638 10.1367 4.58422 10.0339 4.58422 9.90829V9.14684ZM2.16259 9.14684C2.16259 9.0212 2.26476 8.9184 2.38962 8.9184H3.75178C3.87665 8.9184 3.97881 9.0212 3.97881 9.14684V9.90829C3.97881 10.0339 3.87665 10.1367 3.75178 10.1367H2.38962C2.26476 10.1367 2.16259 10.0339 2.16259 9.90829V9.14684ZM11.8491 3.74049V4.65424H0.951782V3.74049C0.951782 3.23602 1.35854 2.82674 1.85989 2.82674H10.941C11.4423 2.82674 11.8491 3.23602 11.8491 3.74049Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.82fefee0b647631dc4bedbe90f060697.svg";
export { ForwardRef as ReactComponent };